import React, { useState, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  callIcon,
  mailIcon,
  linkedinIcon,
  instagramIcon,
  telegramIcon,
  whatsappIcon,
  facebookIcon,
  twitterIcon,
} from '../../images';
import styles from './footer.module.css';
import { MENU_FOOTER } from '../../data';
import Button from '../button';
import Promotion from '../modals/Promotion/Promotion';
import { postRequest } from '../../redux/action';

const Footer = () => {
  const [isPromoPopUp, setPromoPopUp] = useState(false);
  const [email, setEmail] = useState('');

  const handleInputChange = useCallback((e) => {
    setEmail(e.target.value);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const [success, responseData] = await postRequest('/api/news-letters', { data: { email } });

      if (success) {
        toast.success('Subscription successful');
        setEmail('');
      } else {
        console.log('Subscription failed: ', JSON.stringify(responseData));
        const errorMessage =
          responseData.error?.message || JSON.stringify(responseData.error) || 'Email Already Exists';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error during subscription:', error);
      toast.error('An unexpected error occurred');
    }
  };

  const menuItems = useMemo(
    () =>
      MENU_FOOTER.map((item, index) => (
        <div key={index} className={styles['info_block']}>
          <div className={styles['info_block_title']}>{item.name}</div>
          {item.multi ? (
            <div className={`${styles['multi_item']} ${styles['info_block']}`}>
              {item.subMenu.map((subItem, subIndex) => (
                <div key={subIndex} className={styles['sub_menu']}>
                  <div className={styles['sub_sub']}>
                    <div className={styles['sub_title']}>{subItem.name}</div>
                    {subItem.menu?.map((menu, menuIndex) => (
                      <Link key={menuIndex} to={menu.link} className={styles['sub_sub_item_text']}>
                        {menu.name}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={`${styles['no_multi_item']} ${styles['info_block']}`}>
              {item.subMenu.map((subItem, subIndex) => (
                <Link key={subIndex} to={subItem.link} className={styles['sub_sub_item_text']}>
                  {subItem.name}
                </Link>
              ))}
            </div>
          )}
        </div>
      )),
    []
  );

  return (
    <section className={styles['footer']}>
      <div className={styles['first_footer_row']}>
        <div className={styles['first_row_info']}>{menuItems}</div>

        <div className={styles['contacts_info']}>
          <div className={styles['subscribe_box']}>
            <div className={styles['description']}>
              Get exclusive news about upcoming programs, panels and events.
            </div>

            <form onSubmit={handleSubmit}>
              <div className={styles['email_input']}>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="Example@example.com"
                  className={styles['input']}
                  onChange={handleInputChange}
                  value={email}
                />
              </div>
              <Button size variant="secondary" icon="blackArrow" type="submit">
                Subscribe for Newsletter
              </Button>
            </form>
          </div>

          <div className={styles['email_and_phone']}>
            <a href="tel:204-202-7829">
              <img src={callIcon} title="icon" alt="call-icon" loading="lazy" />
              204-202-7829
            </a>

            <a href="mailto:info@theskillgarage.com">
              <img src={mailIcon} title="icon" alt="mail-icon" loading="lazy" />
              info@theskillgarage.com
            </a>
          </div>
        </div>
      </div>

      <div className={styles['last_footer_row']}>
        <div className={styles['last_row_info']}>
          <div className={styles['info_title']}>{new Date().getFullYear()} TheSkillGarage</div>
          <Link to="/terms-and-conditions" className={styles['info_title']}>
            Terms of use
          </Link>
          <Link to="/refund-policy" className={styles['info_title']}>
            Refund Policy
          </Link>
          <Link to="/privacy-policy" className={styles['info_title']}>
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" className={styles['info_title']}>
            Cookie Policy
          </Link>
        </div>

        <div className={styles['social_block']}>
          <SocialIcon href="https://api.whatsapp.com/message/V2IGTURYUJC2B1" src={whatsappIcon} title="WhatsApp" />
          <SocialIcon href="https://x.com/theskillgarage" src={twitterIcon} title="Twitter" />
          <SocialIcon href="https://www.linkedin.com/company/theskillgarage" src={linkedinIcon} title="LinkedIn" />
          <SocialIcon href="https://www.instagram.com/theskillgarage" src={instagramIcon} title="Instagram" />
          <SocialIcon href="https://www.facebook.com/theskillgarage/" src={facebookIcon} title="Facebook" />
        </div>
      </div>

      {isPromoPopUp && <Promotion onClose={() => setPromoPopUp(false)} />}
    </section>
  );
};

const SocialIcon = ({ href, src, title }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" title={title} className={styles['btn social_icon']}>
    <img src={src} title={title} alt={`${title.toLowerCase()}-icon`} loading="lazy" />
  </a>
);

export default React.memo(Footer);
